import React from 'react';
import { RetinaPicture } from 'client/components/RetinaPicture';
import { useT } from 'client/i18n/hooks/useT';
import {
  Container,
  LeftColumn,
  RightColumn,
  Section,
  TextContainer,
  CampaignBudget,
} from './styles';

export function BrandPartners() {
  const t = useT();
  return (
    <Section>
      <h2>
        {t(
          'AdsByAnchorScreen.BrandPartners.Title',
          'Partner with top brands',
          'Ads by Anchor page, brand partners section title'
        )}
      </h2>
      <Container
        className="BrandPartners-imageSection"
        flexDirectionMd="column-reverse"
      >
        <LeftColumn>
          <RetinaPicture
            imagePath="/span/span-headphones-lady"
            alt={t(
              'AdsByAnchorScreen.BrandPartners.MarketingImageAlt',
              'Woman listening to a podcast while looking at her phone',
              'Ads by Anchor page, brand partners marketing image screenreader information'
            )}
            fallbackExtension="jpg"
          />
        </LeftColumn>
        <RightColumn>
          <TextContainer>
            <h3 className="BrandPartners-imageSectionHeading">
              {t(
                'AdsByAnchorScreen.BrandPartners.SPANTitle',
                'Spotify Audience Network',
                'Ads by Anchor page, Spotify Audience Network title'
              )}
            </h3>
            <p>
              {t(
                'AdsByAnchorScreen.BrandPartners.SPANMessage',
                "Spotify Audience Network (SPAN), which powers Automated ads, is Spotify's proprietary audio advertising marketplace in which advertisers of all sizes will be able to connect with listeners consuming a broad range of content. These include Spotify's Originals & Exclusives, podcasts via Megaphone and Anchor, and ad-supported music.",
                'Ads by Anchor page, Spotify Audience Network explanation message'
              )}
            </p>
            <p>
              {t(
                'AdsByAnchorScreen.BrandPartners.SPANBrandsMessage',
                "By using Automated ads, you'll be part of a marketplace with some of the top brands in the world, who want to tap into your unique audience with relevant ads.",
                'Ads by Anchor page, Spotify Audience Network brands access message'
              )}
            </p>
          </TextContainer>
        </RightColumn>
      </Container>
      <Container className="BrandPartners-budgetSection">
        <LeftColumn>
          <TextContainer>
            <h3>
              {t(
                'AdsByAnchorScreen.BrandPartners.BusinessAdvertisingTitle',
                'Are you a business interested in advertising with Anchor and Spotify?',
                'Ads by Anchor page, advertising for businesses section title'
              )}
            </h3>
            <p>
              {t(
                'AdsByAnchorScreen.BrandPartners.BusinessAdvertisingMessage',
                "We're always looking for new partners, and we have a variety of solutions for all budgets and campaign goals. Here's how to get in touch, based on your campaign budget:",
                'Ads by Anchor page, advertising for businesses section message'
              )}
            </p>
          </TextContainer>
        </LeftColumn>
        <RightColumn>
          <TextContainer>
            <CampaignBudget>
              <p>
                {t(
                  'AdsByAnchorScreen.BrandPartners.LowAdvertisingBudgetText',
                  'Under $10,000',
                  'Ads by Anchor page, advertising for businesses with low budget'
                )}
              </p>
              <a
                href="https://anch.co/adstudio"
                target="_blank"
                rel="noreferrer noopener"
              >
                Spotify Ad Studio
              </a>
            </CampaignBudget>
            <CampaignBudget>
              <p>
                {t(
                  'AdsByAnchorScreen.BrandPartners.MidAdvertisingBudgetText',
                  'Between $10,000 and $50,000',
                  'Ads by Anchor page, advertising for businesses with mid-range budget'
                )}
              </p>
              <a
                href="https://spotify.co1.qualtrics.com/jfe/form/SV_4UsiZwa0cpDLaS2"
                target="_blank"
                rel="noreferrer noopener"
              >
                {t(
                  'AdsByAnchorScreen.BrandPartners.MidAdvertisingBudgetLinkText',
                  'Get started',
                  'Ads by Anchor page, get started with Spotify Ad Studio link text'
                )}
              </a>
            </CampaignBudget>
            <CampaignBudget>
              <p>
                {t(
                  'AdsByAnchorScreen.BrandPartners.BigAdvertisingBudgetText',
                  'Above $50,000',
                  'Ads by Anchor page, advertising for businesses with big budget'
                )}
              </p>
              <a
                href="https://anch.co/spotifyaudiencenetwork"
                target="_blank"
                rel="noreferrer noopener"
              >
                {t(
                  'AdsByAnchorScreen.BrandPartners.GetInTouchText',
                  'Get in touch',
                  'Ads by Anchor page, link to reach out to Spotify Ad Studio for businesses with a big advertising budget'
                )}
              </a>
            </CampaignBudget>
          </TextContainer>
        </RightColumn>
      </Container>
    </Section>
  );
}
